import React from 'react';
import { colors } from 'ui_system/compass/utils';

const ArrowDropDown = (props) => {
  const { fill = colors.text.icon } = props;

  return (
    <svg
      height="6px"
      width="10px"
      viewBox="0 0 10 6"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>arrow-drop-down-icon</title>
      <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g transform="translate(-138.000000, -103.000000)" fill={fill}>
          <g transform="translate(48.000000, 96.000000)">
            <polygon
              transform="translate(95.000000, 10.000000) scale(1, -1) translate(-95.000000, -10.000000) "
              points="95 7 100 13 90 13"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ArrowDropDown;
